import { render, staticRenderFns } from "./goVip.vue?vue&type=template&id=a8d5ae62&scoped=true&"
import script from "./goVip.vue?vue&type=script&lang=js&"
export * from "./goVip.vue?vue&type=script&lang=js&"
import style0 from "./goVip.vue?vue&type=style&index=0&id=a8d5ae62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8d5ae62",
  null
  
)

export default component.exports